import actionTypes from '../actions/actionTypes';

export const DEFAULT_STATE = {
  startDate: new Date(),
  endDate: new Date(),
  key: 'selection',
};

const calendarReducer = (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.CALENDAR_RANGE_SET_DATE_RANGE:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.CALENDAR_RANGE_RESET_DATE_RANGE:
      return DEFAULT_STATE;
    default:
      return state;
  }
};

export default calendarReducer;
